import { render } from "./TimerComponent.vue?vue&type=template&id=21ba34dc"
import script from "./TimerComponent.vue?vue&type=script&lang=js"
export * from "./TimerComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__